import React from 'react'
import { Modal } from "react-bootstrap";
//import 'bootstrap/dist/css/bootstrap.min.css';


const ModalInformation = ({ showModal, hideModal, message }) => {
  return (
    <Modal show={showModal} onHide={hideModal} animation={true}  backdrop="static">
      <Modal.Header className="bg-gradient-to-r from-[#3F8CCB] to-[#129FDA]" closeButton>
        <div className="flex justify-center items-center">
          <i className="fas fa-info-circle fa-3x text-white mr-2" />
          <Modal.Title><div className="capitalize text-white text-2xl">Información</div></Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body><div className="rounded-lg mt-3 mb-3 flex items-center justify-center text-2xl text-gray-500 ">{message}</div></Modal.Body>
      <Modal.Footer>
        <button type="button" class="focus:outline-none h-10 text-white text-sm py-1 px-4 rounded-md bg-[#3F8CCB] hover:bg-[#129FDA] hover:shadow-lg"
          onClick={hideModal}>Cerrar</button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalInformation;